module.exports = __webpack_public_path__ + "img/diff.7d4bf4d9.svg";